import type {
  DeliveryArrangement,
  DeliveryFulfillmentType,
  DeliveryStopContact,
  InternalAssigneeType,
} from '../types/delivery';

export type DeliveryNewFormPrefill = {
  fulfillmentType: DeliveryFulfillmentType;
  vehicleType: string;
  pickup: {
    name: string;
    phone: string;
    address: string;
    unitNo: string;
    building: string;
    postal: string;
  };
  dropoffs: Array<{
    demCustomerCode: string;
    demCustomerName: string;
    crmClientId: string | null;
    crmClientCode: string;
    crmMatched: boolean;
    name: string;
    phone: string;
    address: string;
    unitNo: string;
    building: string;
    postal: string;
    notesToDriver: string;
    reason: string;
    documentNo: string;
  }>;
  internalType: InternalAssigneeType;
  internalAssigneeName: string;
  requestedBy: string;
  issueCausedBy: string;
};

function contactToFormFields(contact: DeliveryStopContact) {
  return {
    name: contact.name?.trim() ?? '',
    phone: contact.phone?.trim() ?? '',
    address: contact.address?.trim() ?? '',
    unitNo: contact.unitNo?.trim() ?? '',
    building: contact.building?.trim() ?? '',
    postal: contact.postal?.trim() ?? '',
  };
}

export function arrangementBatchToNewFormPrefill(
  batch: DeliveryArrangement[],
): DeliveryNewFormPrefill | null {
  const head = batch[0];
  if (!head) return null;

  return {
    fulfillmentType: head.fulfillment_type,
    vehicleType: head.vehicle_type?.trim() || 'MOTORCYCLE',
    pickup: contactToFormFields(head.pickup_json),
    dropoffs: batch.map((row) => {
      const demCode =
        row.dem_customer_code?.trim() ||
        row.client_code?.trim() ||
        '';
      return {
        demCustomerCode: demCode,
        demCustomerName: row.client_name?.trim() ?? '',
        crmClientId: row.client_id,
        crmClientCode: row.client_code?.trim() || demCode,
        crmMatched: Boolean(row.client_id),
        ...contactToFormFields(row.dropoff_json),
        notesToDriver: row.dropoff_json.notesToDriver?.trim() ?? '',
        reason: row.reason?.trim() ?? '',
        documentNo: row.document_no?.trim() ?? '',
      };
    }),
    internalType: head.internal_assignee_type ?? 'driver',
    internalAssigneeName: head.internal_assignee_name?.trim() ?? '',
    requestedBy: head.requested_by?.trim() ?? '',
    issueCausedBy: head.issue_caused_by?.trim() ?? '',
  };
}

export function deliveryReorderPath(listBase: string, arrangementId: string): string {
  const base = listBase.replace(/\/$/, '');
  return `${base}/new?reorder=${encodeURIComponent(arrangementId)}`;
}
